<!--@ Modified by Venkata Shyam @Date 30-04-2025 
@Note: modified source and target fields to get diractly from logined workspace and snapshot dropdown to get mapping files-->
<div class="maindiv fullbody" >
    <div style="margin-top:1%">
        <div class="vaultDataloadHeadDiv">
            <h4>Run Migration</h4>
        </div>
    </div>
    <div>
        <form novalidate [formGroup]='validations_form'>
            <div class="dropDownDiv">
              <mat-form-field appearance="outline" class="dropdown">
                <mat-label i18n="@@RCFormulaexpression">Source</mat-label>
                <input
                matInput
                formControlName="source"
                [(ngModel)]="selectedSource"
                required
                placeholder="Enter Source"
                title="Source"
                readonly
              />
                <!-- <mat-select [(ngModel)]="selectedSource" readonly formControlName="source" required title="Target">
                  <mat-option [value]="selectedSource">{{ selectedSource }}</mat-option>
                </mat-select> -->
                <mat-error *ngFor="let validation of validation_messages.source">
                    <span *ngIf="validations_form.get('source').hasError(validation.type) && (validations_form.get('source').dirty || validations_form.get('source').touched)">
                        {{ validation.message }}
                    </span>
                </mat-error>
            </mat-form-field>



                <!-- <mat-form-field appearance="outline" class="dropdown">
                    <mat-label i18n="@@RCFormulaexpression" >Target</mat-label>
                    <mat-select [(ngModel)]="migration.target"
                      (selectionChange)="onTargetSelection($event)"
                      formControlName="target" required title="Target">
                      <mat-option *ngFor="let eachtype of target"
                        [(value)]="eachtype.envName">
                        {{eachtype.envName}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngFor="let validation of validation_messages.target">
                      <span
                        *ngIf="validations_form.get('target').hasError(validation.type)
                        && (validations_form.get('target').dirty ||
                        validations_form.get('target').touched)">
                        {{ validation.message }}
                      </span>
                    </mat-error>
                </mat-form-field> -->
                <mat-form-field appearance="outline" class="dropdown">
                  <mat-label i18n="@@RCFormulaexpression">Target</mat-label>
                  <input
                  matInput
                  formControlName="target"
                  [(ngModel)]="selectedTarget"
                  required
                  placeholder="Enter Target"
                  title="Target"
                  readonly
                />
                  <mat-error *ngFor="let validation of validation_messages.target">
                    <span
                      *ngIf="validations_form.get('target').hasError(validation.type)
                      && (validations_form.get('target').dirty ||
                      validations_form.get('target').touched)">
                      {{ validation.message }}
                    </span>
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="dropdown">
                    <mat-label i18n="@@RCFormulaexpression">Migration Type</mat-label>
                    <input
                    matInput
                    formControlName="migrationType"
                    [(ngModel)]="migrationSelectedType"
                    required
                    placeholder="Enter Migration Type"
                    title="Migration Type"
                    readonly
                  />
                    <mat-error *ngFor="let validation of validation_messages.migrationType">
                      <span
                        *ngIf="validations_form.get('migrationType').hasError(validation.type)
                        && (validations_form.get('migrationType').dirty ||
                        validations_form.get('migrationType').touched)">
                        {{ validation.message }}
                      </span>
                    </mat-error>
                </mat-form-field>

                <ng-container *ngIf="DisplayObject && updateDropdowns">
                  <mat-form-field appearance="outline" class="dropdown">
                      <mat-label i18n="@@RCFormulaexpression">Object Group Names</mat-label>
                      <mat-select formControlName="objectGroups" (selectionChange)="onObjectGroupSelection($event)" multiple required title="Object Groups">
                        <mat-option *ngIf="(objectGroups.length === 1 && objectGroups[0] === 'No Object Groups Found')" disabled>
                          No Object Groups Found
                      </mat-option>
                      <ng-container *ngIf="!(objectGroups.length === 1 && objectGroups[0] === 'No Object Groups Found')">
                          <mat-option *ngFor="let group of objectGroups" [value]="group.objectGroupId">
                              {{ group.objectgroupname }}
                          </mat-option>
                      </ng-container>
                      </mat-select>
                      <mat-error *ngFor="let validation of validation_messages.objectGroups">
                          <span *ngIf="validations_form.get('objectGroups').hasError(validation.type)
                          && (validations_form.get('objectGroups').dirty || validations_form.get('objectGroups').touched)">
                              {{ validation.message }}
                          </span>
                      </mat-error>
                  </mat-form-field>
              </ng-container>
            </div>
        </form>
    </div>
    <div *ngIf="(migration.migrationType === 'Data Virtualization (Direct Data API)'||migration.migrationType === 'Data Virtualization (Loader)' || migration.migrationType === 'Vault Safety Data Ingestion')  && updateDropdowns">
      <form novalidate [formGroup]='validations_form'>
    <div class="dropDownDiv">
    <mat-form-field appearance="outline" class="dropdown">
      <mat-label i18n="@@RCFormulaexpression">Data Lake and Reports</mat-label>
      <mat-select [(ngModel)]="migration.dataLakeAndReports" (selectionChange)="onDataLakeAndReportsSelection($event)" formControlName="dataLakeAndReports" required title="Data Lake and Reports">
          <mat-option *ngFor="let eachtype of dataLakeAndReportsOptions" [(value)]="eachtype.lookupvalue">
              {{eachtype.lookupvalue}}
          </mat-option>
      </mat-select>
      <mat-error *ngFor="let validation of validation_messages.dataLakeAndReports">
          <span *ngIf="validations_form.get('dataLakeAndReports').hasError(validation.type) && (validations_form.get('dataLakeAndReports').dirty || validations_form.get('dataLakeAndReports').touched)">
              {{ validation.message }}
          </span>
      </mat-error>
  </mat-form-field>
  <div div *ngIf="migration.dataLakeAndReports && migration.dataLakeAndReports != 'PARQUET' && migration.dataLakeAndReports !== 'Casewise Json'">
  <mat-form-field appearance="outline" class="dropdown">
    <mat-label i18n="@@RCFormulaexpression">Data Lake Type</mat-label>
    <mat-select [(ngModel)]="migration.dataLakeType" (selectionChange)="onDataLakeTypeSelection($event)" formControlName="dataLakeType" required title="Data Lake Type">
        <mat-option *ngFor="let eachtype of dataLakeTypeOptions" [(value)]="eachtype.lookupvalue">
            {{eachtype.lookupvalue}}
        </mat-option>
    </mat-select>
    <mat-error *ngFor="let validation of validation_messages.dataLakeType">
        <span *ngIf="validations_form.get('dataLakeType').hasError(validation.type) && (validations_form.get('dataLakeType').dirty || validations_form.get('dataLakeType').touched)">
            {{ validation.message }}
        </span>
    </mat-error>
</mat-form-field>
</div>
 
<div div *ngIf="migration.dataLakeAndReports  ">
<mat-form-field appearance="outline" class="dropdown">
  <mat-label i18n="@@RCFormulaexpression">JSONTOCSV Validation Reports</mat-label>
  <mat-select [(ngModel)]="migration.JSONTOCSV_Validation_Reports" (selectionChange)="onValidationSelection($event)" formControlName="JSONTOCSV_Validation_Reports" required title="JSONTOCSV_Validation_Reports">
      <mat-option *ngFor="let eachtype of JSONTOCSV_Validation_ReportsOptions" [value]="eachtype.lookupvalue">
          {{eachtype.lookupvalue}}
      </mat-option>
  </mat-select>
  <mat-error *ngFor="let validation of validation_messages.JSONTOCSV_Validation_Reports">
    <span *ngIf="validations_form.get('JSONTOCSV_Validation_Reports').hasError(validation.type) && (validations_form.get('JSONTOCSV_Validation_Reports').dirty || validations_form.get('JSONTOCSV_Validation_Reports').touched)">
        {{ validation.message }}
    </span>
</mat-error>
</mat-form-field>
</div>

<mat-form-field appearance="outline" class="dropdown">
  <mat-label i18n="@@RCFormulaexpression">Persistence EMR</mat-label>
  <mat-select [(ngModel)]="migration.persistenceEmr" (selectionChange)="onPersistenceEmrSelection($event)" formControlName="persistenceEmr" required title="Persistence EMR">
      <mat-option *ngFor="let eachtype of persisteneceEmrOptions" [(value)]="eachtype.lookupvalue">
          {{eachtype.lookupvalue}}
      </mat-option>
  </mat-select>
  <mat-error *ngFor="let validation of validation_messages.persistenceEmr">
      <span *ngIf="validations_form.get('persistenceEmr').hasError(validation.type) && (validations_form.get('persistenceEmr').dirty || validations_form.get('persistenceEmr').touched)">
          {{ validation.message }}
      </span>
  </mat-error>
</mat-form-field>
</div>
</form>
<div div *ngIf="migration.dataLakeAndReports && migration.dataLakeAndReports !== 'JSON'&& migration.dataLakeAndReports !== 'Casewise Json'">
  <div style="margin-left: 1%;">
  <form novalidate [formGroup]="validations_form_input">
      <mat-form-field appearance="outline" style="width: 230px;">
        <mat-label i18n="@@RCFormulaexpression">Integrator</mat-label>
        <mat-select [(ngModel)]="migration.intergrator" (selectionChange)="onIntegratorSelection($event)" formControlName="intergrator" required title="Integrator">
            <mat-option *ngFor="let eachtype of integratorSelectionOptions" [(value)]="eachtype.lookupvalue">
                {{eachtype.lookupvalue}}
            </mat-option>
        </mat-select>
          <mat-error *ngIf="validations_form_input.get('DatasetName').invalid && validations_form_input.get('DatasetName').touched">
            <span *ngIf="validations_form_input.get('DatasetName').errors.required">
              Integrator is required.
            </span>
            <span *ngIf="validations_form_input.get('DatasetName').touched">
              Uppercase letters, spaces, and special characters are not allowed.
            </span>
          </mat-error>
      </mat-form-field>
  </form>
</div>
<div style="margin-left: 1%;" *ngIf="migration.intergrator=='GLUE' || migration.intergrator=='SNOWFLAKE'">
  <form novalidate [formGroup]="validations_form_input">
      <mat-form-field appearance="outline">
          <mat-label i18n="@@TMSTAFFMASTERfirstname"> DataBaseName</mat-label>
          <input matInput type="text" placeholder="DataBaseName"
            formControlName="DatasetName"
            [(ngModel)]="migration.DatasetName" maxlength="100"
            required title="DataBaseName"
            pattern="[a-z0-9-_]+"
            (input)="validateInput($event)">
          <mat-error *ngIf="validations_form_input.get('DatasetName').invalid && validations_form_input.get('DatasetName').touched">
            <span *ngIf="validations_form_input.get('DatasetName').errors.required">
              DataBaseName Name is required.
            </span>
            <span *ngIf="validations_form_input.get('DatasetName').touched">
              Uppercase letters, spaces, and special characters are not allowed.
            </span>
          </mat-error>
      </mat-form-field>
  </form>
</div>
</div>
</div>
    <div class="dataExtractionLevel">
      <div >
        <form novalidate [formGroup]="validations_form_input">
            <mat-form-field appearance="outline" style="width: 485px;">
                <mat-label i18n="@@TMSTAFFMASTERfirstname">Select Mapping Snapshot</mat-label>
                <mat-select [(ngModel)]="snapshotSelected" (selectionChange)="onMappingSnapshotChange($event.value)" formControlName="snapshotVersion" required title="snapshotVersion">
                  <mat-option *ngFor="let option of snapshot" [value]="option">
                      {{option}}
                  </mat-option>
              </mat-select>
                <mat-error *ngFor="let validation of validation_messages.snapshotVersion">
                  <span
                    *ngIf="validations_form_input.get('snapshotVersion').hasError(validation.type)
                    && (validations_form_input.get('snapshotVersion').dirty ||
                    validations_form_input.get('snapshotVersion').touched)">
                    {{ validation.message }}
                  </span>
                </mat-error>
            </mat-form-field>
        </form>
      </div>
    </div>
    <div class="dataExtractionLevel" *ngIf="updateDropdowns">
      <label title="Data Extraction Type">Data Extraction Type :  </label>
  <div [formGroup]="validations_form_input" >
      <!-- <h6 style="margin-top: 1.3%;" title="Data Extraction Type">Data Extraction Type: </h6> -->

        <mat-radio-group [formControl]="validations_form_input.get('dataExtractionType')" style="margin-top: 1.2%;  margin-left: 10px;" required title="dataExtractionType"(change)="onSelectDataExtraction($event.value)">

            <mat-radio-button title="Full Data" style="font-size: medium"  value="Full Data" #full>Full Data</mat-radio-button>
            <mat-radio-button title="Partial Data" *ngIf="partialData" style="font-size: medium; margin-left: 25px"  value="Partial Data" #partial>Partial Data</mat-radio-button>
        </mat-radio-group>
      <div class="error-msg" style="font-weight: 400; font-size: 11px; color: #f44336;" >
    
        <mat-error *ngIf="validations_form_input.get('dataExtractionType').invalid && validations_form_input.get('dataExtractionType').touched">
                    <span *ngIf="validations_form_input.get('dataExtractionType').errors.required">
                        Data Extraction Type is required.
                    </span>
                </mat-error>
                </div>
                </div>
    </div>


    <div class="dataExtractionLevel">
        <div *ngIf="uploadFile && partialData">
          <mat-radio-group [(ngModel)]="selectedExtractionType" style="margin-top: 1.2%; margin-left: 1%;">
            <mat-radio-button title="CSV Extraction" value="CSV Extraction" style="font-size: medium ">CSV Extraction</mat-radio-button>
            <mat-radio-button title="Attachment Extraction" value="Attachment Extraction" style="font-size: medium; margin-left: 4px">Attachment Extraction</mat-radio-button>
          </mat-radio-group>
          

            <form novalidate [formGroup]="validations_form_upload" class="dataExtractionUpload">
                <mat-form-field appearance="outline">
                    <mat-label i18n="@@TMshoppingcomplexchooseimage">Choose File</mat-label>
                    <input
                      title="Choose File"
                      matInput
                      class="file-path validate"
                      type="text"
                      maxlength="250"
                      placeholder="Choose File"
                      formControlName="fileData"
                      id="imageName"
                      [(ngModel)]="fileData.fileName"
                      readonly
                      (change)="imagePhotofunction($event,'csv')"
                    />
                </mat-form-field>
                <div class="file-field" style="width: 20%;margin-right: 10px;">
                  <a class="btn-floating  btn-sm ml-4 m-0" style="display: flex; justify-content: center; align-items: center;">
                    <input type="file" style="display: none;" (change)="imagePhotofunction($event, '.csv')" #fileUploadLink>
                    <em  style="text-rendering: auto;color:black;" class="fas fa-paperclip mt-0"
                    title="Attach File"
                    (click)="fileUploadLink.click()">
                   </em>
                  </a>
                </div>
            </form>
          </div>
        </div>
      
  
    

    <div style="margin-left: 1%; margin-top: 3%;">
        <form novalidate [formGroup]="validations_form_input">
            <mat-form-field appearance="outline">
                <mat-label i18n="@@TMSTAFFMASTERfirstname">Remarks</mat-label>
                <input matInput type="text" placeholder="Remarks"
                  formControlName="remarks"
                  [(ngModel)]="migration.remarks" maxlength="100"[readonly]="isReadOnly"
                  required title="Remarks">
                  <mat-error *ngIf="validations_form_input.get('remarks').invalid && validations_form_input.get('remarks').touched">
                    <span *ngIf="validations_form_input.get('remarks').errors.required">
                        Remarks is required.
                    </span>
                </mat-error>

            </mat-form-field>
        </form>
    </div>
    <div style="text-align: center;">
        <button i18n="@@TargetCancel" type="button" (click)="cancel()" title="Cancel"
                class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                style="padding: .3rem 1.6rem;font-size: .85rem;" [style.border-color]="buttonColor">
          Cancel
        </button>
        <button  i18n="@@TMRunButton" type="button" (click)="startmigration()" *ngIf="updateDropdowns"
                [style.background-color]="buttonColor" title="Start Run"
                class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize">
          Start Run 
        </button>
        <button  i18n="@@TMRunButton" type="button" (click)="updatemigration()" *ngIf="isReadOnly"
                [style.background-color]="buttonColor" title="Update Run"
                class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize">
          Update Run
        </button>

      </div>
</div>
